// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3HRgi","label":"Category_label__2lvWN","content":"Category_content__fc21Z","header":"Category_header__27zE2","location":"Category_location__1VnhI"};